import axios from 'axios'

const instance = axios.create()

export const getApi = (url, params) => {
  return instance.get(url, { params })
}

export const postApi = (url, data) => {
  return instance.post(url, data)
}

export const putApi = (url, data) => {
  return instance.put(url, data)
}

export const delApi = (url, data) => {
  return instance.delete(url, { data })
}

export default instance